export const AUTH_SCOPES = {
  SWITCHPROFILE_READ: 'COMMON.SWITCHPROFILE:READ',
  GENERIC_WEBFORM_ADD: 'COMMON.MANAGE_GENERIC_WEBFORM:ADD',
  TODO_READ: 'COMMON.MANAGE_TODO_ITEM:READ',
  ENFORCEMENT_PAYMENT_READ: 'COMMON.MANAGE_ENFORCEMENT_PAYMENT:READ',
  LOGOUT_READ: 'COMMON.AUTHENTICATION_LOGOUT:READ',
};
